import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    ColorFill: {
        fill: '#ffffff'
    }
});

const AddbeneficiaryIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);

    return (
        <>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 37.8 37.8"
                style={{ width: '32px' }}
            >
                <g>
                    <polygon
                        className={classesInline.ColorFill}
                        points="27.4,20.4 25.2,20.4 25.2,22.6 23,22.6 23,24.8 25.2,24.8 25.2,27 27.4,27 27.4,24.8 29.6,24.8 
		29.6,22.6 27.4,22.6 	"
                    />
                    <path
                        className={classesInline.ColorFill}
                        d="M19,0C8.5,0,0.1,8.5,0.1,18.9S8.5,37.8,19,37.8s18.9-8.5,18.9-18.9S29.4,0,19,0z M15,7.5
		c0.1-0.1,0.2-0.3,0.4-0.4c2.4-2.2,6-2,8.2,0.4c0.7,0.8,1.2,1.8,1.4,2.9c-0.6-0.5-1.3-0.8-2.1-0.8c-0.6,0-1.1,0.2-1.6,0.4l-0.6,0.3
		l0,0c-0.9,0.6-2,0.6-2.8,0l0,0L17.3,10c-0.5-0.3-1-0.4-1.6-0.4c-0.8,0-1.5,0.3-2.1,0.8C13.8,9.4,14.3,8.3,15,7.5z M13.3,13.5
		c0.1-0.2,0.3-0.3,0.6-0.4L13.7,12c0-0.2,0-0.3,0.1-0.5c0.1-0.1,0.1-0.2,0.2-0.3c0.7-0.9,2-1.2,3.1-0.6l0.5,0.3
		c1.1,0.7,2.5,0.7,3.6,0l0.5-0.3c1-0.6,2.3-0.4,3.1,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.5l-0.2,1.1
		c0.6,0.2,0.9,0.9,0.8,1.5l-0.2,0.8c-0.2,0.7-0.7,1.1-1.4,1.3c-0.7,2-2.6,3.3-4.8,3.3c-2.1,0-4-1.3-4.8-3.3
		c-0.7-0.1-1.2-0.6-1.4-1.3l-0.2-0.8C13,14.2,13.1,13.8,13.3,13.5z M22.1,29.2h-9.8c-0.2,0-0.4-0.2-0.4-0.4v-3.2c0,0,0,0,0,0
		c0-0.2-0.2-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.3,0.4v3.2c0,0.2-0.2,0.4-0.4,0.4H8.6c-0.2,0-0.4-0.2-0.4-0.4v-4.1c0-1.8,1.3-3.3,3-3.6
		l4-0.7c0,0,0,0,0,0c0.1,0,0.3,0.1,0.3,0.3c0.1,2,1.7,3.5,3.7,3.5h0c0.4,0,0.8,0.3,0.8,0.7c0.3,1.5,1.1,2.8,2.2,3.7
		C22.6,28.8,22.5,29.2,22.1,29.2z M26.3,29.2c-3.1,0-5.5-2.5-5.5-5.5c0-3.1,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5
		C31.8,26.7,29.3,29.2,26.3,29.2z"
                    />
                </g>
            </svg>
        </>
    );
};

export default AddbeneficiaryIcon;
